import {
  defineComponent, inject, provide, ref,
} from 'vue';

import MallList from '../../mall/pages/mallList';

export default defineComponent({
  name: 'CouponTab',
  props: {
  // 页面样式版本
    styleVersion: {
      type: String,
      default: '',
    },
  },
  setup: (props, { expose }) => {
    provide('styleVersion', props.styleVersion);
    const titleBarHeight = inject('titleBarHeight') as () => number;
    const titleBarHeightValue = titleBarHeight?.() || 0;
    const mallListRef = ref<any>(null);

    // 监听tab切换
    const onTabChange = (options: { tabKey: string; }) => {
      if (
        mallListRef.value
        && typeof mallListRef.value.onTabChange === 'function'
      ) {
        mallListRef.value.onTabChange(options);
      }
    };

    expose({
      onTabChange,
    });

    return () => (
      <MallList
        ref={mallListRef}
        titleBarHeight={titleBarHeightValue}
      />
    );
  },
});
